import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SCVService } from 'src/app/service/scv.service';
import { TranslateService } from '@ngx-translate/core';


@Component({
  selector: 'app-consent',
  templateUrl: './consent.component.html',
  styleUrls: ['./consent.component.css']
})
export class ConsentComponent implements OnInit {

  consentText: string;
  constructor(public translate: TranslateService, public dialogRef: MatDialogRef<ConsentComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any, private scvService: SCVService) {

  }

  ngOnInit() {
    this.consentText = this.translate.instant('LABEL.UPLOAD.WAIT');
    this.scvService.getConsentText().subscribe((value) => {
      this.consentText = value;
    },(error)  => {
      this.consentText = '(This is just the example text, once we received default text from the PSA it will be updated)';
    });

  }

}
